<template lang="pug">  
  v-row(no-gutters)
    v-col(cols=12)
      v-row.mx-1(
        no-gutters
        cols=12
        md=6
      )
        v-col.px-1.mb-1(
          cols=12
          md=3
        ).pt-3
          n-select-game-type(
            v-model='gameTypeSelect'
            :group-type-id="1"
            @change='gameSelect'
          )
        v-col.px-1.mb-1(
          cols=12
          md=3
        ).pt-3
          selectGameStatusScope(
            v-model='status'
            @input='statusSelect'
          )

        v-col.px-1(cols='12', md='3').pt-3
          n-datepicker-range(:date-range='dateRange', :max-days="15", @setDateRange='setDateRange')
    v-col(cols=12) 
      lotto-card(:items='items' @detail='viewLotto')
      div(ref="observer" v-if="!isEnd")
    v-col(v-if="false" cols=12) 
      n-data-table-card-result.mt-3(
        :headers='headers'
        :items='items'
        :meta='meta' 
        @nextpage='nextpage'
      )
        template(#item.win_amount='{ item }')
          b(:class="classColor(item)") {{ item.win_amount | currency }} 

        template(#item.centerActionEffectToCard='{ item }') 
          v-icon(
            v-if='item.game_type && item.room' 
            @click='viewLotto(item)'
          ) mdi-eye

        template(#item.game_type='{ item }')
          | {{ item.room ? (item.room || {}).name : (item.game_type || {}).name }}

        template(#item.stake_status.name='{ item }') 
          v-chip.pa-1.text-center(
            dark
            outlined
            :color='colorStake (item)'
          ) {{ item.stake_status.name  }}

        template(#item.rightActionEffectToCard='{item}')
          | {{ item.created_at | dateFormat}}
        template(#item.leftActionEffectToCard='{ item }') 
          v-btn(
            v-if='canReturnList (item)'
            rounded
            outlined
            color='green'
            @click='removeLotto(item)'
          )
            v-icon(small) mdi-close
            | {{ $t('button.return-lotto-list') }} 
    loading-status(:had-data='hadData')

</template> 
<script>  
import { dateConvert, dateFormat, getPastDate } from '@/plugins/time'
import selectGameStatusScope from './SelectGameStatusScope'
import lottoCard from './LottoCard'
import { st as apiSt } from '@/apis'

export default {
  components: {
    selectGameStatusScope,
    lottoCard
  },
  data: () => ({
    dateRange : ['',''],
    gameTypeSelect : {
      game_type_name : '',
      game_type_id : '',
      game_id : '',
      game_name : '' 
    }, 
    status: null,
    hadData : false,
    items: [],
    page:1, 
    meta : {},
    headers:[  
      { text: 'table.view-lotto-list', value: 'centerActionEffectToCard'},
      { text: 'table.ref-id', value: 'ref_id' },
      { text: 'table.lotto-type', value: 'game_type' },
      { text: 'table.date-time', value: 'rightActionEffectToCard'},
      { text: 'table.bet-amount', value: 'bet_amount', format:'currency' },
      { text: 'table.win-amount', value: 'win_amount' },
      { text: 'table.description', value: 'description' },
      { text: 'table.status', value: 'stake_status.name' },
      { text: 'table.return-lotto-list', value: 'leftActionEffectToCard' },
    ],
    observer: null,
    isEnd: false,
  }),

  async created () {
    const pastDate = this.getPastDate(10)
    this.dateRange[0] = pastDate
  },

  mounted () {
    this.observer = new IntersectionObserver((entries) => {

      if (entries[0].isIntersecting) {

        if (this.hadData) {
          this.nextpage(this.page + 1)
        }
      }
    })

    if (this.$refs.observer) {
      this.observer.observe(this.$refs.observer)
    }
  },

  methods: {   
    dateFormat,
    dateConvert,
    getPastDate,
    canReturnList (item) {
      return item.stake_status.id === 2 && (dateConvert(item.room.locked_at)>new Date())
    },
    colorStake (item) { 
      return item.stake_status.id===3 ? 'success':item.stake_status.id===2 ? 'blue' : 'red'
    },
    classColor (item) {
      return item.stake_status.id===3 ? 'green--text' : 'red--text'
    },
    gameSelect (game_type,game) {  
      this.$ga.event('Button', 'SelectGameType', 'StakeListPage','' )
      this.gameTypeSelect = {
        game_type_name : game_type.name,
        game_type_id : game_type.id,
        game_id : game.id,
        game_name : game.name,
      }
      this.page = 1
      this.load()
    },

    setDateRange (value) { 
      this.dateRange = value
      if(this.dateRange[1] !== ''){
        this.$ga.event('Button', 'SelectDateRange', 'StakeListPage','' )
        this.page = 1
        this.load ()
      } 
    },

    statusSelect () {
      this.page = 1
      this.load()
    },
    
    async load (params = {}) { 
      // reset after cancelled
      if (params.reset) {
        this.page = 1
      }

      params = {
        page : this.page,
        game_type_id : this.gameTypeSelect.game_type_id,
        start_date : this.dateRange[0],
        end_date : this.dateRange[1],
        game_id : this.gameTypeSelect.game_id,
        // is_only_internal : 0 
        group_game_type_id: 1, // lotto
        status: this.status
      }

      this.hadData = false
      const [err,data,,meta ] = await apiSt.getAllList(params) 
      this.hadData = true

      if(err){ 
        this.$alert('',err,'warning')  
        return
      }

      if (params.page == 1) {
        this.items = data 
      } else {
        this.items.push(...data) 
      }

      this.meta = meta

      if (params.page >= meta.total_page) {
        this.isEnd = true;
      } else {
        this.isEnd = false

        this.$nextTick(() => {
          if (this.observer && this.$refs.observer) {
            this.observer.observe(this.$refs.observer)
          }
        })
      }
    },

    viewLotto (item) {
      this.$ga.event('Button', 'ViewStakeListInfo', 'StakeListPage','')
      this.$emit('addDialog', item)
    },

    removeLotto (item) { 
      this.$ga.event('Button', 'RemoveStakeList', 'StakeListPage','')
      if(dateConvert(item.room.locked_at)>new Date()) {
        this.$emit('remove', item.list_uuid) 
      }
    },

    nextpage (value) {
        this.page = value
        this.load ()
    }
  }
};
</script>